import React from 'react'

const resizeObserverContext = React.createContext(0)

export default resizeObserverContext
